export default __webpack_public_path__ + "static/media/misc-drawerB-768w.6dfae02f.avif";